'use client'

import {
  IconDefinition,
  faCircleQuestion,
  faFilePdf,
  faFileText,
  faImage,
  faPlayCircle,
} from '@fortawesome/free-regular-svg-icons'
import { faCheck, faQuestion, faVideo } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { cn } from '~/lib/utils'
import { CourseUnit } from '~/payload-types'

const BLOCK_ICON_MAP: Record<CourseUnit['components'][0]['blockType'], IconDefinition> = {
  kaltura: faVideo,
  objective: faCheck,
  pdf: faFilePdf,
  embed: faPlayCircle,
  klicker: faQuestion,
  text: faFileText,
  carousel: faImage,
  'olat-link': faCircleQuestion,
}

function BlockIcon({
  blockType,
  className,
}: {
  blockType: CourseUnit['components'][0]['blockType']
  className?: string
}) {
  if (BLOCK_ICON_MAP[blockType]) {
    return (
      <FontAwesomeIcon icon={BLOCK_ICON_MAP[blockType]} className={cn('mr-2 w-4', className)} />
    )
  }

  return null
}

export default BlockIcon
